import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { ClientReferralsCtaPopup } from './client-referrals-cta-popup';
import { useOnAfterRouteChange } from '../../../infra/routing';
import { isCtaShownForPathname, setCtaDismissedDateToNow, wasCtaDismissed } from './utils';
import { useApiQuery } from '../../../infra/api';
import { getSessionShop, useSession } from '../../../infra/session';
import { flagNames, showIfFeatureFlag } from '../../../infra/feature-flags';
import { endpoints } from '../network';
export var JustClientReferralsCtaContainer = function () {
    var _a = useState(isCtaShownForPathname(window.location.pathname)), isPathnameAllowed = _a[0], setIsPathnameAllowed = _a[1];
    useOnAfterRouteChange(function (nextRoute) {
        setIsPathnameAllowed(isCtaShownForPathname(nextRoute.pathname));
    }, []);
    var _b = useState(wasCtaDismissed()), wasDismissed = _b[0], setWasDismissed = _b[1];
    var handleDismiss = function () {
        setCtaDismissedDateToNow();
        setWasDismissed(true);
    };
    var session = useSession().data;
    var shop = getSessionShop(session);
    var _c = useApiQuery({
        endpoint: endpoints.clientReferralProgramQuery,
        payload: {
            shopId: shop === null || shop === void 0 ? void 0 : shop.id,
        },
        options: {
            enabled: !!shop,
        },
    }), referralProgram = _c.data, isFetched = _c.isFetched;
    var shouldShowCta = isPathnameAllowed && !wasDismissed && isFetched && !referralProgram;
    if (!shouldShowCta) {
        return null;
    }
    return _jsx(ClientReferralsCtaPopup, { onClose: handleDismiss });
};
export var ClientReferralsCtaContainer = showIfFeatureFlag(flagNames.CLIENT_REFERRALS)(JustClientReferralsCtaContainer);
